import { generateReceivablesReport, generateClientDemandReport ,generateFinancialPositionReport} from './InvoiceGenerator';
import React, { useState, useEffect } from 'react';
import { db } from '../firebase/config';
import { 
  collection, 
  getDocs, 
  query, 
  orderBy, 
  Timestamp, 
  doc, 
  runTransaction, 
  addDoc, 
  updateDoc,
  where
} from 'firebase/firestore';
import { ClientLedger } from './ClientLedger';
import { SalesLedger } from './SalesLedger';
import { CashAccount } from './CashAccount';
import { JournalEntries } from './JournalEntries';
import { OrderCreation } from './OrderCreation';
import { ProductManagement } from './ProductManagement';
import AccountsPayable from './AccountsPayable';
import AllAccounts from './AllAccounts';
import PettyCash from './PettyCash';
import AccountsReceivable from './AccountsReceivable';
import ReceivablesVsPayables from './ReceivablesVsPayables';

// Helper: format number with thousand separators (UGX)
const formatMoney = (value) => {
  if (value === '' || value === undefined || value === null) return '';
  const num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
  if (isNaN(num)) return '';
  return num.toLocaleString('en-US');
};

// Helper: convert formatted string back to number
const parseMoney = (formatted) => {
  if (!formatted) return '';
  const cleaned = formatted.replace(/,/g, '');
  const num = parseFloat(cleaned);
  return isNaN(num) ? '' : num;
};

export const LedgerSystem = () => {
  const [activeTab, setActiveTab] = useState('client');
  const [selectedClient, setSelectedClient] = useState(null);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [showReportsModal, setShowReportsModal] = useState(false);
  const [clientsWithBalance, setClientsWithBalance] = useState([]);
  const [allOrders, setAllOrders] = useState([]);
  const [allPayments, setAllPayments] = useState([]);

  console.log('orders track',allOrders)

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    setLoading(true);
    try {
      const clientsRef = collection(db, 'clients');
      const snapshot = await getDocs(clientsRef);
      const clientsList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setClients(clientsList);
      if (clientsList.length > 0 && !selectedClient) {
        setSelectedClient(clientsList[0]);
      }
    } catch (error) {
      console.error('Error fetching clients:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshData = () => {
    setRefreshKey(prev => prev + 1);
    fetchClients();
  };
   
  const fetchReportData = async () => {
    try {
      const ordersSnapshot = await getDocs(collection(db, 'orders'));
      const ordersData = ordersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setAllOrders(ordersData);
      
      const paymentsSnapshot = await getDocs(collection(db, 'payments'));
      const paymentsData = paymentsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setAllPayments(paymentsData);
      
      const clientsWithBal = clients.map(client => {
        const clientOrders = ordersData.filter(o => o.clientId === client.id);
        const clientPayments = paymentsData.filter(p => p.clientId === client.id);
        const totalOrdered = clientOrders.reduce((sum, o) => sum + (o.totalSellingPrice || 0), 0);
        const totalPaid = clientPayments.reduce((sum, p) => sum + (p.amount || 0), 0);
        const balance = totalOrdered - totalPaid;
        return { ...client, balance, totalOrdered, totalPaid };
      });
      setClientsWithBalance(clientsWithBal);
    } catch (error) {
      console.error('Error fetching report data:', error);
    }
  };
   
  return React.createElement(
    'div',
    { style: styles.container },
    React.createElement(
      'div',
      { style: styles.header },
      React.createElement(
        'div',
        null,
        React.createElement('h1', { style: styles.title }, 'Ledger Management'),
        React.createElement('p', { style: styles.subtitle }, 'Double-entry accounting system with real-time tracking')
      ),
      React.createElement(
        'div',
        { style: styles.headerActions },
        React.createElement(
          'button',
          { style: styles.buttonPrimary, onClick: () => setShowProductModal(true) },
          '+ Manage Products'
        ),
        React.createElement(
          'button',
          { style: styles.buttonPrimary, onClick: () => setShowOrderModal(true) },
          '+ New Order'
        ),
        React.createElement(
          'button',
          { style: styles.buttonSecondary, onClick: () => setShowPaymentModal(true) },
          '+ Record Payment'
        ),
        React.createElement(
          'button',
          { 
            style: { ...styles.buttonPrimary, background: '#8b5cf6', color: '#ffffff' }, 
            onClick: async () => {
              try {
                const ordersSnapshot = await getDocs(collection(db, 'orders'));
                const ordersData = ordersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                
                const paymentsSnapshot = await getDocs(collection(db, 'payments'));
                const paymentsData = paymentsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                
                const accountsPayableSnapshot = await getDocs(collection(db, 'accountsPayable'));
                const accountsPayable = accountsPayableSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                
                const clientsWithBal = clients.map(client => {
                  const clientOrders = ordersData.filter(o => o.clientId === client.id);
                  const clientPayments = paymentsData.filter(p => p.clientId === client.id);
                  const totalOrdered = clientOrders.reduce((sum, o) => sum + (o.totalSellingPrice || 0), 0);
                  const totalPaid = clientPayments.reduce((sum, p) => sum + (p.amount || 0), 0);
                  const balance = totalOrdered - totalPaid;
                  return { ...client, balance, totalOrdered, totalPaid };
                });
                
                await generateFinancialPositionReport(
                  clientsWithBal,
                  ordersData,
                  paymentsData,
                  clients,
                  accountsPayable
                );
              } catch (error) {
                console.error('Error generating financial report:', error);
                alert('Error generating report: ' + error.message);
              }
            } 
          },
          '📊 Financial Position'
        ),
        React.createElement(
          'button',
          { 
            style: { ...styles.buttonSecondary, background: '#10b981', color: '#ffffff' }, 
            onClick: async () => {
              await fetchReportData();
              setShowReportsModal(true);
            } 
          },
          '📊 Reports'
        )
      )
    ),
    activeTab === 'client' && React.createElement(
      'div',
      { style: styles.clientSelector },
      React.createElement('label', { style: styles.selectorLabel }, 'Select Client'),
      React.createElement(
        'select',
        {
          style: styles.clientSelect,
          value: selectedClient?.id || '',
          onChange: (e) => {
            const client = clients.find(c => c.id === e.target.value);
            setSelectedClient(client);
          }
        },
        clients.map(client => 
          React.createElement('option', { key: client.id, value: client.id }, 
            `${client.name} ${client.email ? `- ${client.email}` : ''}`
          )
        )
      )
    ),
    React.createElement(
      'div',
      { style: styles.tabsContainer },
      [
        { id: 'client', label: 'Client Account', icon: '📋' },
        { id: 'sales', label: 'Sales Account', icon: '💰' },
        { id: 'cash', label: 'Cash Account', icon: '💵' },
        { id: 'journal', label: 'Journal Entries', icon: '📝' },
        { id: 'products', label: 'Products & BOM', icon: '📦' },
        { id: 'recvspayables', label: 'Receivables vs Payables', icon: '📊' },
        { id: 'receivables', label: 'Accounts Receivable', icon: '📋' },
        { id: 'payables', label: 'Accounts Payable', icon: '📋' },
        { id: 'allaccounts', label: 'All Accounts', icon: '👥' },
        { id: 'pettycash', label: 'Petty Cash', icon: '💰' }, 
      ].map(tab =>
        React.createElement(
          'button',
          {
            key: tab.id,
            style: {
              ...styles.tabButton,
              ...(activeTab === tab.id ? styles.tabButtonActive : {})
            },
            onClick: () => setActiveTab(tab.id)
          },
          React.createElement('span', { style: styles.tabIcon }, tab.icon),
          React.createElement('span', null, tab.label)
        )
      )
    ),
    React.createElement(
      'div',
      { style: styles.contentArea },
      activeTab === 'client' && selectedClient && React.createElement(ClientLedger, {
        key: refreshKey,
        client: selectedClient,
        onRefresh: refreshData,
        onShowPaymentModal: () => setShowPaymentModal(true)
      }),
      activeTab === 'sales' && React.createElement(SalesLedger, { key: refreshKey }),
      activeTab === 'cash' && React.createElement(CashAccount, { key: refreshKey }),
      activeTab === 'journal' && React.createElement(JournalEntries, { key: refreshKey }),
      activeTab === 'recvspayables' && React.createElement(ReceivablesVsPayables, { key: refreshKey }),
      activeTab === 'receivables' && React.createElement(AccountsReceivable, { key: refreshKey }),
      activeTab === 'payables' && React.createElement(AccountsPayable,{ key: refreshKey }),
      activeTab === 'products' && React.createElement(ProductManagement, {
        key: refreshKey,
        onRefresh: refreshData
      }),
      activeTab === 'pettycash' && React.createElement(PettyCash, { key: refreshKey }),
      activeTab === 'allaccounts' && React.createElement(AllAccounts, { key: refreshKey })
    ),
    showOrderModal && React.createElement(OrderCreation, {
      onClose: () => setShowOrderModal(false),
      onSuccess: () => {
        setShowOrderModal(false);
        refreshData();
      }
    }),
    showPaymentModal && React.createElement(PaymentModal, {
      clients: clients,
      onClose: () => setShowPaymentModal(false),
      onSuccess: () => {
        setShowPaymentModal(false);
        refreshData();
      }
    }),
    showProductModal && React.createElement(ProductManagement, {
      isModal: true,
      onClose: () => setShowProductModal(false),
      onRefresh: refreshData
    }),
    showReportsModal && React.createElement(ReportsModal, {
      clientsWithBalance: clientsWithBalance,
      allOrders: allOrders,
      allPayments: allPayments,
      onClose: () => setShowReportsModal(false),
      onGenerateReceivables: () => generateReceivablesReport(clientsWithBalance, allOrders, allPayments),
      onGenerateDemandReport: () => generateClientDemandReport(clientsWithBalance, allOrders, allPayments)
    })
  );
};

// Payment Modal Component (modified to include comma formatting)
const PaymentModal = ({ clients, onClose, onSuccess }) => {
  const [selectedClient, setSelectedClient] = useState('');
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState('');
  const [amountRaw, setAmountRaw] = useState('');      // raw numeric string (or number)
  const [amountDisplay, setAmountDisplay] = useState(''); // formatted with commas
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [reference, setReference] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [fetchingOrders, setFetchingOrders] = useState(false);

  React.useEffect(() => {
    if (selectedClient) {
      fetchOrdersWithBalance();
    } else {
      setOrders([]);
    }
  }, [selectedClient]);

  const fetchOrdersWithBalance = async () => {
    setFetchingOrders(true);
    try {
      const ordersRef = collection(db, 'orders');
      const q = query(
        ordersRef, 
        where('clientId', '==', selectedClient),
        where('balanceDue', '>', 0),
        orderBy('orderDate', 'desc')
      );
      const snapshot = await getDocs(q);
      const ordersList = snapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data() 
      }));
      console.log('Fetched orders with balance:', ordersList);
      setOrders(ordersList);
      
      if (ordersList.length === 0) {
        setError('No pending orders found for this client');
      } else {
        setError('');
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
      setError('Error loading orders');
    } finally {
      setFetchingOrders(false);
    }
  };

  const handleAmountChange = (e) => {
    const raw = e.target.value;
    // Allow only digits and one decimal point
    let cleaned = raw.replace(/[^0-9.]/g, '');
    const parts = cleaned.split('.');
    if (parts.length > 2) cleaned = parts[0] + '.' + parts.slice(1).join('');
    const numValue = parseFloat(cleaned);
    const formatted = isNaN(numValue) ? '' : formatMoney(numValue);
    setAmountDisplay(formatted);
    setAmountRaw(isNaN(numValue) ? '' : numValue);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const order = orders.find(o => o.id === selectedOrder);
      if (!order) {
        throw new Error('Order not found');
      }
      
      const paymentAmount = parseFloat(amountRaw);
      
      if (isNaN(paymentAmount) || paymentAmount <= 0) {
        throw new Error('Please enter a valid amount');
      }
      
      if (paymentAmount > order.balanceDue) {
        throw new Error(`Amount exceeds balance due of ${order.balanceDue.toLocaleString()} UGX`);
      }

      await runTransaction(db, async (transaction) => {
        const orderRef = doc(db, 'orders', selectedOrder);
        const orderDoc = await transaction.get(orderRef);
        const currentOrder = orderDoc.data();
        
        const newBalance = currentOrder.balanceDue - paymentAmount;
        
        transaction.update(orderRef, {
          balanceDue: newBalance,
          status: newBalance === 0 ? 'completed' : currentOrder.status,
          updatedAt: Timestamp.now()
        });
        
        const paymentRef = doc(collection(db, 'payments'));
        transaction.set(paymentRef, {
          paymentId: paymentRef.id,
          orderId: selectedOrder,
          clientId: selectedClient,
          amount: paymentAmount,
          paymentDate: Timestamp.now(),
          paymentMethod: paymentMethod,
          reference: reference || `Payment for ${currentOrder.orderNumber}`,
          createdAt: Timestamp.now()
        });
        
        const journalRef = doc(collection(db, 'journalEntries'));
        transaction.set(journalRef, {
          journalId: journalRef.id,
          transactionId: paymentRef.id,
          transactionType: 'payment',
          date: Timestamp.now(),
          entries: [
            {
              account: 'cash',
              accountName: 'Cash Account',
              debit: paymentAmount,
              credit: 0,
              description: `Payment received from ${currentOrder.orderNumber}`
            },
            {
              account: 'accounts_receivable',
              accountName: 'Accounts Receivable',
              debit: 0,
              credit: paymentAmount,
              description: `Payment applied to ${currentOrder.orderNumber}`
            }
          ],
          createdAt: Timestamp.now(),
          createdBy: 'system'
        });
      });
      
      alert('Payment recorded successfully!');
      onSuccess();
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return React.createElement(
    'div',
    { style: modalStyles.overlay, onClick: onClose },
    React.createElement(
      'div',
      { style: modalStyles.container, onClick: (e) => e.stopPropagation() },
      React.createElement(
        'div',
        { style: modalStyles.header },
        React.createElement('h2', { style: modalStyles.title }, 'Record Payment'),
        React.createElement('button', { style: modalStyles.closeButton, onClick: onClose }, '×')
      ),
      React.createElement(
        'form',
        { onSubmit: handleSubmit, style: modalStyles.form },
        React.createElement(
          'div',
          { style: modalStyles.formGroup },
          React.createElement('label', { style: modalStyles.label }, 'Client'),
          React.createElement(
            'select',
            {
              style: modalStyles.select,
              value: selectedClient,
              onChange: (e) => {
                setSelectedClient(e.target.value);
                setSelectedOrder('');
                setAmountDisplay('');
                setAmountRaw('');
              },
              required: true
            },
            React.createElement('option', { value: '' }, 'Select Client'),
            clients.map(client =>
              React.createElement('option', { key: client.id, value: client.id }, client.name)
            )
          )
        ),
        React.createElement(
          'div',
          { style: modalStyles.formGroup },
          React.createElement('label', { style: modalStyles.label }, 'Order'),
          fetchingOrders ? 
            React.createElement('div', { style: { padding: '10px', color: '#64748b' } }, 'Loading orders...') :
            React.createElement(
              'select',
              {
                style: modalStyles.select,
                value: selectedOrder,
                onChange: (e) => {
                  setSelectedOrder(e.target.value);
                  setAmountDisplay('');
                  setAmountRaw('');
                },
                required: true,
                disabled: !selectedClient || orders.length === 0
              },
              React.createElement('option', { value: '' }, orders.length === 0 ? 'No pending orders' : 'Select Order'),
              orders.map(order =>
                React.createElement('option', { key: order.id, value: order.id },
                  `-Model Number: ${order?.items?.[0]?.modelNumber} -- Product Name: ${order?.items?.[0]?.productName} - Balance: ${order.balanceDue.toLocaleString()} UGX`
                )
              )
            )
        ),
        React.createElement(
          'div',
          { style: modalStyles.formGroup },
          React.createElement('label', { style: modalStyles.label }, 'Amount (UGX)'),
          React.createElement('input', {
            type: 'text',
            style: modalStyles.input,
            value: amountDisplay,
            onChange: handleAmountChange,
            placeholder: 'Enter amount (e.g., 1,000,000)',
            required: true
          })
        ),
        React.createElement(
          'div',
          { style: modalStyles.formGroup },
          React.createElement('label', { style: modalStyles.label }, 'Payment Method'),
          React.createElement(
            'select',
            {
              style: modalStyles.select,
              value: paymentMethod,
              onChange: (e) => setPaymentMethod(e.target.value)
            },
            React.createElement('option', { value: 'cash' }, 'Cash'),
            React.createElement('option', { value: 'bank' }, 'Bank Transfer'),
            React.createElement('option', { value: 'mobile' }, 'Mobile Money')
          )
        ),
        React.createElement(
          'div',
          { style: modalStyles.formGroup },
          React.createElement('label', { style: modalStyles.label }, 'Reference (Optional)'),
          React.createElement('input', {
            type: 'text',
            style: modalStyles.input,
            value: reference,
            onChange: (e) => setReference(e.target.value),
            placeholder: 'Reference number or notes'
          })
        ),
        error && React.createElement('div', { style: modalStyles.error }, error),
        React.createElement(
          'div',
          { style: modalStyles.actions },
          React.createElement('button', { type: 'button', style: modalStyles.buttonSecondary, onClick: onClose }, 'Cancel'),
          React.createElement('button', { type: 'submit', style: modalStyles.buttonPrimary, disabled: loading || !selectedOrder || !amountRaw },
            loading ? 'Processing...' : 'Record Payment'
          )
        )
      )
    )
  );
};

// Reports Modal Component (unchanged)
const ReportsModal = ({ clientsWithBalance, allOrders, allPayments, onClose, onGenerateReceivables, onGenerateDemandReport }) => {
  return React.createElement(
    'div',
    { style: modalStyles.overlay, onClick: onClose },
    React.createElement(
      'div',
      { style: { ...modalStyles.container, maxWidth: '500px' }, onClick: (e) => e.stopPropagation() },
      React.createElement(
        'div',
        { style: modalStyles.header },
        React.createElement('h2', { style: modalStyles.title }, 'Generate Reports'),
        React.createElement('button', { style: modalStyles.closeButton, onClick: onClose }, '×')
      ),
      React.createElement(
        'div',
        { style: { padding: '24px' } },
        React.createElement(
          'div',
          { style: { marginBottom: '20px' } },
          React.createElement('h3', { style: { fontSize: '16px', fontWeight: '600', marginBottom: '12px', color: '#1e293b' } }, 'Accounts Receivable'),
          React.createElement('p', { style: { fontSize: '13px', color: '#64748b', marginBottom: '12px' } }, 
            `Total Outstanding: ${clientsWithBalance.filter(c => c.balance > 0).reduce((sum, c) => sum + c.balance, 0).toLocaleString()} UGX`
          ),
          React.createElement(
            'button',
            {
              style: { ...modalStyles.buttonPrimary, width: '100%' },
              onClick: onGenerateReceivables
            },
            'Generate Receivables Report'
          )
        ),
        React.createElement(
          'div',
          { style: { marginBottom: '20px' } },
          React.createElement('h3', { style: { fontSize: '16px', fontWeight: '600', marginBottom: '12px', color: '#1e293b' } }, 'Client Demand Report'),
          React.createElement('p', { style: { fontSize: '13px', color: '#64748b', marginBottom: '12px' } }, 
            `Clients to Follow Up: ${clientsWithBalance.filter(c => c.balance > 0).length}`
          ),
          React.createElement(
            'button',
            {
              style: { ...modalStyles.buttonPrimary, width: '100%', background: '#f59e0b' },
              onClick: onGenerateDemandReport
            },
            'Generate Demand Report'
          )
        ),
        React.createElement(
          'div',
          { style: { marginBottom: '20px' } },
          React.createElement('h3', { style: { fontSize: '16px', fontWeight: '600', marginBottom: '12px', color: '#1e293b' } }, 'Client Statement'),
          React.createElement('p', { style: { fontSize: '13px', color: '#64748b', marginBottom: '12px' } }, 
            'Generate statement for specific client'
          ),
          React.createElement(
            'select',
            {
              style: modalStyles.select,
              id: 'clientSelect',
              defaultValue: ''
            },
            React.createElement('option', { value: '' }, 'Select Client'),
            clientsWithBalance.map(client =>
              React.createElement('option', { key: client.id, value: client.id }, client.name)
            )
          ),
          React.createElement(
            'button',
            {
              style: { ...modalStyles.buttonSecondary, width: '100%', marginTop: '12px' },
              onClick: async () => {
                const clientId = document.getElementById('clientSelect').value;
                if (!clientId) {
                  alert('Please select a client');
                  return;
                }
                const client = clientsWithBalance.find(c => c.id === clientId);
                const clientOrders = allOrders.filter(o => o.clientId === clientId);
                const clientPayments = allPayments.filter(p => p.clientId === clientId);
                const { generateStatement } = await import('./InvoiceGenerator');
                generateStatement(client, clientOrders, clientPayments);
              }
            },
            'Generate Client Statement'
          )
        )
      )
    )
  );
};

// Styles (unchanged)
const styles = {
  container: {
    minHeight: '100vh',
    background: '#f8fafc',
    padding: '32px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '32px',
    flexWrap: 'wrap',
    gap: '16px'
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '8px',
    letterSpacing: '-0.02em'
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b'
  },
  headerActions: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap'
  },
  buttonPrimary: {
    background: '#7f1a2e',
    color: '#ffffff',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
  },
  buttonSecondary: {
    background: '#ffffff',
    color: '#1e293b',
    padding: '10px 20px',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },
  clientSelector: {
    background: '#ffffff',
    padding: '16px 24px',
    borderRadius: '16px',
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'wrap',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    border: '1px solid #eef2f6'
  },
  selectorLabel: {
    fontWeight: '600',
    color: '#334155',
    fontSize: '14px'
  },
  clientSelect: {
    padding: '10px 16px',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    fontSize: '14px',
    minWidth: '240px',
    background: '#ffffff',
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 0.2s ease'
  },
  tabsContainer: {
    display: 'flex',
    gap: '8px',
    marginBottom: '24px',
    background: '#ffffff',
    padding: '6px',
    borderRadius: '14px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    border: '1px solid #eef2f6',
    flexWrap: 'wrap'
  },
  tabButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 20px',
    background: 'transparent',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#64748b',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },
  tabButtonActive: {
    background: '#7f1a2e',
    color: '#ffffff',
    boxShadow: '0 2px 4px rgba(127, 26, 46, 0.2)'
  },
  tabIcon: {
    fontSize: '16px'
  },
  contentArea: {
    background: '#ffffff',
    borderRadius: '20px',
    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)',
    border: '1px solid #eef2f6',
    overflow: 'hidden'
  }
};

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  container: {
    background: '#ffffff',
    borderRadius: '24px',
    width: '90%',
    maxWidth: '520px',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #eef2f6'
  },
  title: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#0f172a'
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '28px',
    cursor: 'pointer',
    color: '#94a3b8',
    transition: 'color 0.2s ease'
  },
  form: {
    padding: '24px'
  },
  formGroup: {
    marginBottom: '20px'
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '500',
    color: '#334155',
    marginBottom: '8px'
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s ease'
  },
  select: {
    width: '100%',
    padding: '10px 14px',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    fontSize: '14px',
    background: '#ffffff',
    cursor: 'pointer',
    outline: 'none'
  },
  actions: {
    display: 'flex',
    gap: '12px',
    marginTop: '24px'
  },
  buttonPrimary: {
    flex: 1,
    background: '#7f1a2e',
    color: '#ffffff',
    padding: '12px',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },
  buttonSecondary: {
    flex: 1,
    background: '#f1f5f9',
    color: '#334155',
    padding: '12px',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },
  error: {
    background: '#fef2f2',
    color: '#dc2626',
    padding: '12px',
    borderRadius: '10px',
    fontSize: '13px',
    marginBottom: '16px'
  }
};

export default LedgerSystem;